// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__-451g","content":"styles_content__3-y7r","checkbox":"styles_checkbox__2K7Zy","checkboxLabel":"styles_checkboxLabel__3D-UR"};